export enum ClaimReason {
    None = "None",
    CancelledPartReceived = "CancelledPartReceived",
    PartsQuotedIncorrectly = "PartsQuotedIncorrectly",
    ShortShipment = "ShortShipment",
    WrongPartShipped = "WrongPartShipped",
    DoubleShipped = "DoubleShipped",
    BadCross = "BadCross",
    LiteratureError = "LiteratureError",
    PackagedIncorrectly = "PackagedIncorrectly",
    UpsClaim = "UpsClaim",
    WrongPartPickedOrShipped = "WrongPartPickedOrShipped",
    McfTechOrBookWrong = "McfTechOrBookWrong",
    DmgdPartDamagedBox = "DmgdPartDamagedBox",
    Shorted = "Shorted",
    OverShipped = "OverShipped",
    PackageError = "PackageError",
    ShippedToWrongAddress = "ShippedToWrongAddress",
    WrongFreightOrShipVia = "WrongFreightOrShipVia",
    CarrierClaimDamageLoss = "CarrierClaimDamageLoss",
    CarrierSrvcFailure = "CarrierSrvcFailure",
    NotInSalableCondition = "NotInSalableCondition",
    CarrierServiceFailure = "CarrierServiceFailure",
    IncompletePart = "IncompletePart",
    IncorrectFreightCharge = "IncorrectFreightCharge",
    IncompletePartKitSet = "IncompletePartKitSet",
    MixedParts = "MixedParts",
    DmgdPartNotDefective = "DmgdPartNotDefective",
    EuropeAndSingapore = "EuropeAndSingapore",
    CreditAsExpressReturn = "CreditAsExpressReturn",
    ClaimCanceledByMcfa = "ClaimCanceledByMcfa",
    OverMaximumReturnDays = "OverMaximumReturnDays",
    McfaPolicyReturn = "McfaPolicyReturn",
    RaymondExpReturn = "RaymondExpReturn",
    MexSAParteIncorrecta = "MexSAParteIncorrecta",
    MexSAPartesDanadas = "MexSAPartesDanadas",
    MexSAEnvioIncompleto = "MexSAEnvioIncompleto",
    MexSAEnvioEquivocado = "MexSAEnvioEquivocado",
    MexSATransporteReclamo = "MexSATransporteReclamo",
    BillingError = "BillingError",
    PartsTechnicalError = "PartsTechnicalError",
}
